import {
  type AuctionActivatedMessage,
  type AuctionBidPlacedMessage,
  type AuctionClosedMessage,
  type AuctionOutbidMessage,
  type AuctionTimerExtendedMessage,
  type AuctionUpdatedMessage,
  type AuctionVisibilityChangedMessage,
  type AuctionWonMessage,
  RegistrationAPIEvents,
} from '@furality/centrifugo-types';

export type AuctionEvent = (typeof RegistrationAPIEvents)[keyof typeof RegistrationAPIEvents];

export type AuctionEventPayloadMap = {
  [RegistrationAPIEvents.Activated]: AuctionActivatedMessage;
  [RegistrationAPIEvents.Outbid]: AuctionOutbidMessage;
  [RegistrationAPIEvents.Won]: AuctionWonMessage;
  [RegistrationAPIEvents.BidPlaced]: AuctionBidPlacedMessage;
  [RegistrationAPIEvents.StateClosed]: AuctionClosedMessage;
  [RegistrationAPIEvents.VisibilityChanged]: AuctionVisibilityChangedMessage;
  [RegistrationAPIEvents.TimerExtended]: AuctionTimerExtendedMessage;
  [RegistrationAPIEvents.Updated]: AuctionUpdatedMessage;
  // don't use
  [RegistrationAPIEvents.StateOpened]: never;
};

export type AuctionEventEnvelope = {
  [E in AuctionEvent]: { type: E; data: AuctionEventPayloadMap[E] };
}[AuctionEvent];

const AUCTION_EVENT_VALUES = new Set<string>(Object.values(RegistrationAPIEvents));

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const parseAuctionEnvelope = (raw: unknown): AuctionEventEnvelope | null => {
  if (!isObject(raw)) {
    return null;
  }

  const { type, data } = raw;

  if (typeof type !== 'string' || !AUCTION_EVENT_VALUES.has(type) || !isObject(data)) {
    return null;
  }

  if (typeof data['auctionId'] !== 'string') {
    return null;
  }

  return { type, data } as unknown as AuctionEventEnvelope;
};
